import {
  FETCH_PRODUCT_LIST_PENDING,
  FETCH_PRODUCT_LIST_REJECTED,
  FETCH_PRODUCT_LIST_FULFILLED,
} from '../constants/productList';

const initialState = {
  error: [],
  pending: true,
  products: [],
  sorts: [],
  facets: [],
  facetsApplied: [],
  pagination: {},
  search_text: null,
};

export const productList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_LIST_FULFILLED:
      //SPECIAL PAGE CASE FOR PRODUCT LIST
      if (action.response.product) {
        return {
          ...state,
          products: [action.response.product],
          sorts: [],
          facets: [],
          facetsApplied: [],
          pagination: {
            total_count: 1,
          },
          search_text: null,
          pending: false,
          error: [],
        };
      } else {
        const facetsApplied = action.response.facets
          .filter((facet) => {
            return (
              facet.data.choices.filter((choice) => {
                return choice.is_selected === true;
              }).length > 0
            );
          })
          .filter((facet) => {
            return facet.key !== 'category_ids';
          });
        return {
          ...state,
          products: action.response.products,
          sorts: action.response.sorters,
          facets: action.response.facets,
          facetsApplied: [...facetsApplied],
          pagination: action.response.pagination,
          search_text: action.response.search_text,
          pending: false,
          error: [],
        };
      }

    case FETCH_PRODUCT_LIST_PENDING:
      return {
        ...state,
        pending: true,
        error: [],
      };

    case FETCH_PRODUCT_LIST_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/productList.js